import * as React from 'react'
import { useTheme } from '@mui/material/styles'
import { LocationsHeaderProps } from '../typings'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { getStyles } from './stylings'

export const LocationsHeader: React.FC<LocationsHeaderProps> = (props) => {
  const {
    listViewHeader = 'Bill-to / Location',
    open,
    canCreateLocations,
  } = props

  const tidalThemeActive = useTidalThemeActive()
  const styles = getStyles(
    props,
    useTheme(),
    tidalThemeActive,
    canCreateLocations,
  )

  return (
    <>
      <Typography
        component="label"
        variant="body1"
        sx={{ ...styles.header, display: 'inline-block' }}
      >
        {listViewHeader}
      </Typography>
      <IconButton color="primary" size="small">
        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </IconButton>
    </>
  )
}

LocationsHeader.displayName = 'LocationsHeader'
